/* eslint-disable max-len */
import { Heading, Text } from 'evergreen-ui';
import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';

function Privacy() {
  useEffect(() => {
    document.title = 'Privacy Policy · WappGrow';
  }, []);

  function heading(text, fontSize = 20) {
    return (<Heading fontSize={fontSize}>{text}</Heading>);
  }
  function link(text) {
    return (<a style={{ color: '#027eb5' }} href="http://orkaapps.com/">{text}</a>);
  }
  function content(text) {
    return (<Text fontSize={18} lineHeight={1.5}>{text}</Text>);
  }
  return (
    <div
      style={{
        width: '70%', padding: '50px 0px', margin: 'auto', rowGap: 22, display: 'flex', flexDirection: 'column',
      }}
    >
      {heading(
        <>
          Privacy Policy for
          {' '}
          {link('orkaapps.com')}
        </>,
        25,
      )}
      {heading('Last Updated: November 1, 2023')}
      {content(
        <>
          Welcome to
          {' '}
          {link('orkaapps.com')}
          {' '}
          (the "Site"). At
          {' '}
          {link('orkaapps.com')}
          , we respect your privacy and are committed to protecting your personal data. This Privacy Policy will inform you as to how we look after your personal data when you visit our website (regardless of where you visit it from), and it tells you about your privacy rights and how the law protects you.
        </>,
      )}
      {heading('1. Information We Collect')}
      {content('We collect and process the following data about you:')}
      {content(
        <>
          {heading('-Information you provide:')}
          <br />
          We collect personal information that you voluntarily provide to us, including your name, email address, postal address, phone number, and payment information when you register on our site, place an order, subscribe to our newsletter, or fill out a form.
        </>,
      )}
      {content(
        <>
          {heading('-Automatically collected information:')}
          <br />
          When you visit our website, we may automatically collect certain information about your device, including your IP address, browser type, referring website, pages you viewed, and the dates/times when you accessed the website. We use cookies and similar tracking technologies to collect this information
        </>,
      )}
      {heading('2. How We Use Your Information')}
      {content(
        <>
          We use the information we collect for various purposes, including to:
          <p style={{ margin: 0 }}>- Process and fulfill your</p>
          <p style={{ margin: 0 }}>- Communicate with you about your orders and provide customer support</p>
          <p style={{ margin: 0 }}> - Improve and optimize our website</p>
          <p style={{ margin: 0 }}>- Send you marketing and promotional materials if you have opted in to receive them</p>
          <p style={{ margin: 0 }}>- Prevent fraudulent activities and monitor the security of the website</p>
        </>,
      )}
      {heading('3. Disclosure of Your Information')}
      {content('We do not sell, trade, or otherwise transfer your personal information to third parties without your consent. However, we may share your information with trusted third parties who assist us in operating our website, conducting our business, or servicing you, as long as those parties agree to keep this information confidential.')}
      {heading('4. Your Rights')}
      {content(
        <>
          You have the right to:
          <p style={{ margin: 0 }}>- Access the personal data we hold about you</p>
          <p style={{ margin: 0 }}>- Correct inaccuracies in your personal data</p>
          <p style={{ margin: 0 }}>- Request deletion of your personal data</p>
          <p style={{ margin: 0 }}>- Object to the processing of your personal data</p>
          <p style={{ margin: 0 }}>- Request the transfer of your personal data to another party</p>
          To exercise these rights, please contact us using the information provided in the "Contact Us" section below.
        </>,
      )}
      {heading('5. Security')}
      {content('We are committed to ensuring that your information is secure. We have implemented reasonable measures and follow generally accepted industry standards to protect the personal information submitted to us, both during transmission and once we receive it.')}
      {heading('6. Changes to Our Privacy Policy')}
      {content('We may update our Privacy Policy from time to time. Any changes we make to our Privacy Policy will be posted on this page, and, where appropriate, notified to you by email.')}
      {heading('7. Contact Us')}
      {content('If you have any questions about our Privacy Policy or the information we collect about you, please contact us at:')}
      {content(
        <>
          Email:
          {link('contact@orkaapps.in')}
        </>,
      )}
      {content(
        <>
          Postal Address:
          <p style={{ margin: 0 }}>{link('orkaapps.com')}</p>
          <p style={{ margin: 0 }}>India.</p>
        </>,
      )}
      {content(
        <>
          Thank you for visiting
          {' '}
          {link('orkaapps.com')}
          . Your privacy is important to us.
        </>,
      )}
    </div>
  );
}

export { Privacy };